import { Close, HelpOutline } from "@material-ui/icons";
import $ from "jquery";
import moment from "moment";
import React from "react";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import StepZilla from "react-stepzilla";
import {
  addPublicFormAction,
  getPublicFormAction,
} from "../../../actions/PublicFormsActions";
import { createTransactionAction } from "./../../../actions/BuyerAgentMasterTemplateActions";
import {
  getLeadSourceOptionsAction,
  checkTransShortNameAction,
  changeTransactionStatusAction,
  getTimezoneListAction,
  createTaskAction,
} from "./../../../actions/TransactionActions";
import { getAddressFromZipcodeAction } from "./../../../actions/commonActions";
import {
  getContactByEmailAction,
  getContactsActions,
  getUserRolesAction,
  buyerAgentsAction,
} from "./../../../actions/UserActions";
import { getSubscriptionCounterAction } from "./../../../actions/SubscriptionReportAction";
import { setFolderPermissionAction } from "../../../actions/DocActions";
import APIUtil from "./../../../config/APIUtil";
import UrlConstants from "./../../../config/UrlConstants";
import AssignVendor from "./AssignVendor";
import PropertyInfo from "./PropertyInfo";
import {
  formatPhoneNumber,
  removeDashFromMobile,
  contigencyFormat,
  listingAgentDataFormat,
  closingAgentDataFormat,
  toastMessage,
  cryptoTokenDecode,
  getContingencyData,
  convertTimeToMinutes,
  getToday,
  getMinutes,
  convertTZ,
  getUTCdate,
  getMinutesWithUTCTZ,
} from "./../../Common/Common";
import * as code from "./../../../config/Constants";
import * as message from "./../../../config/CommonMessages";
import { getTransactionTypeAction } from "./../../../actions/TransactionTypeActions";
import {
  addPathwayToTransactionAction,
  getBuyerAgentMasterTemplateAction,
} from "./../../../actions/PathwayActions";

class CreateTransaction extends React.Component {
  userType = cryptoTokenDecode().usertype;
  currentType = localStorage.getItem("currentRole");
  studioName = localStorage.getItem("companyName");
  defaultState = {
    condo: false,
    builtBefore1978: false,
    hoa: false,
    homeWarranty: false,
    draft: false,
    leadSource: "",
    emd: "0",
    otherEMD: [],
    agreedOpenPrice: 0.0,
    commission: 100.0,
    transactionType: "",
    property: {
      image: [],
      name: this.studioName,
      street: "",
      street1: "",
      city: "",
      zipcode: "",
      state: "",
    },
    buyer: {
      email: "",
      firstname: "",
      lastname: "",
      mobileNumber: "",
    },
    buyers: [],
    startDate: moment(),
    endDate: moment(),
    campaign: "",
    contingencies: [],
    contiUpdated: false,
    isShowPrompt: false,
    promptMsg: "",
    showLoader: false,
    fees: [],
    agentPercentage: 100,
    shortName: "",
    heldBy: "",
    shortNameErr: "",
    listingAgents: [],
    closingAgents: [],
    contiChanged: false,
    listingAgentEdit: true,
    closingAgentEdit: true,
    userTimezone: "America/New_York",
    contacts: [],
    ownerId:
      cryptoTokenDecode().usertype === message.ACCTOWNER
        ? localStorage.getItem("ID")
        : localStorage.getItem("ownerId"),
    users: [],
    defaultPathwayid: "",
    tempImages:[],
    dateTime:null,
  };

  constructor(props) {
    super(props);
    this.state = this.defaultState;
    this.currentRole = !!this.currentType ? this.currentType.toUpperCase() : "";
  }

  componentWillMount() {
    this.props.getLeadSourceOptionsAction();
    this.props.getTimezoneListAction();
    this.props.getTransactionTypeAction();
    this.getAllContacts();
    this.getpathways();
  }

  getTransactionData() {
    return this.state;
  }

  getAllContacts() {
    let rolename = "admin";
    if (
      cryptoTokenDecode().usertype === message.VENDOR &&
      this.currentRole === message.BUYERAGENT
    ) {
      rolename = "ep";
      this.props
        .getContactsActions(
          rolename,
          "?id=" + localStorage.getItem("ownerId") + "&rolename=" + rolename
        )
        .then((epContactsRes) => {
          this.props.getUserRolesAction(
            "?id=" + localStorage.getItem("ownerId")
          );
          this.setState({
            contacts: this.props.contacts || [],
          });
        });
    } else {
      this.props.getContactsActions().then((contactRes) => {
        this.props.getUserRolesAction();
        this.setState({
          contacts: this.props.contacts || [],
        });
      });
    }
  }

  getpathways() {
    this.props
      .getBuyerAgentMasterTemplateAction()
      .then((res) => {
        let pthId = "";
        let activeUserPathway = null;

        for (
          var i = 0, len = this.props.buyerMasterTemplates.length;
          i < len;
          i++
        ) {
          let tempDataObj = this.props.buyerMasterTemplates[i];
          //set admin's default as selected if found
          if (
            !!tempDataObj.default &&
            tempDataObj.system &&
            !tempDataObj.isDeleted
          ) {
            pthId = tempDataObj._id;
          }
          //set user's default as selected if found
          else if (
            !!tempDataObj.default &&
            !tempDataObj.system &&
            !tempDataObj.isDeleted
          ) {
            activeUserPathway = tempDataObj._id;
          }
        }
        if (activeUserPathway !== null) {
          pthId = activeUserPathway;
        }

        this.setState({ defaultPathwayid: pthId });
      })
      .catch((err) => {});
  }

  /**
   * @desc update transaction data with field name
   * @param {*} field
   * @param {*} value
   */
  updateTransactionData(field, value) {
    // console.log("==field==", field);
    // console.log("==field value==", value);
    switch (field) {
      case "property_street":
        return (this.state.property.street = value);
      case "property_street1":
        return (this.state.property.street1 = value);
      case "property_city":
        return (this.state.property.city = value);
      case "property_state":
        return (this.state.property.state = value);
      case "property_zipcode":
        return (this.state.property.zipcode = value);
      case "property_image":
        return (this.state.property.image = value);
      case "buyer_firstname":
        return (this.state.buyer.firstname = value);
      case "buyer_lastName":
        return (this.state.buyer.lastname = value);
      case "buyer_email":
        return (this.state.buyer.email = value);
      case "buyer_mobileNumber":
        return (this.state.buyer.mobileNumber = value);
      default: {
        var fieldState = {};
        fieldState[field] = value;
        return this.setState(fieldState);
      }
    }
  }

  /**
   * @desc get step number and performed actions
   * @param {*} step
   */
  getLastStep(step) {
    if (step === 0) {
      $(".saveBtn").html("Next");
    }

    if (step === 1) {
      $(".saveBtn").html("Save & Start");
    }

    if (step === 2) {
      let isDraftedSteps = this.state.draft;
      //If transaction drafted by step 1 then check validation on step 2 confirm & save
      if (isDraftedSteps) {
        $("#prev-button").trigger("click");
        $("#next-button").trigger("click");

        let errs = this.child.getFormErrs();

        this.checkShortName(this.state.shortName).then((res) => {
          if (res.isAccepted) {
            if (errs === undefined) {
              //If step 1 form is valid to save transaction as schedule
              this.setState({ draft: false }, () => {
                this.showPrompt();
              });
            } else {
              //If step 1 have validation errors
              return false;
            }
          } else {
            this.setState({ shortNameErr: code.ERROR });
            $("#prev-button").trigger("click");
            //If step 1 have validation errors
            return false;
          }
        });
      } else {
        this.setState({ draft: false }, () => {
          this.showPrompt();
        });
      }
    }
  }

  isShowPrompt() {
    this.setState({ isShowPrompt: !this.state.isShowPrompt });
  }

  /**
   * @desc show prompt with msg of vendor not assigned, contigencies not selected, campaign not selected
   */
  showPrompt() {
    let vendorExist = this.checkVendorAssigned();

    if (this.state.campaign === "" && this.state.contingencies.length === 0) {
      this.setState({
        promptMsg:
          "Creating a transaction without selecting a template or contingencies will require manual task creation. Are you sure you want to continue?",
      });
      this.setState({ isShowPrompt: true });
    }
    if (this.state.campaign === "" && this.state.contingencies.length > 0) {
      this.setState({
        promptMsg:
          "Creating a transaction without selecting a template or contingencies will require manual task creation. Are you sure you want to continue?",
      });
      this.setState({ isShowPrompt: true });
    }
    if (this.state.campaign !== "" && this.state.contingencies.length === 0) {
      this.setState({
        promptMsg:
          "Creating a transaction without selecting a template or contingencies will require manual task creation. Are you sure you want to continue?",
      });
      this.setState({ isShowPrompt: true });
    }

    // if (this.state.campaign !== "" && this.state.contingencies.length > 0) {
    //   if (vendorExist) {
    //     this.setState({ isShowPrompt: false, promptMsg: "", showLoader: true });
    //   } else {
    //     this.setState({
    //       promptMsg:
    //         "You have not assigned any contacts to participants or contingencies. Are you sure you want to continue?"
    //     });
    //     this.setState({ isShowPrompt: true });
    //   }
    // }

    if (this.state.listingAgents.length === 0) {
      toastMessage(code.ERROR, "Please select an artist");
    } else if (this.state.buyers.length === 0) {
      toastMessage(code.ERROR, "Please select a client");
    } else if (!vendorExist) {
      toastMessage(code.ERROR, "Please assign someone to First Appointment");
    } else {
      this.submitAction();
    }
  }

  /**
   * @desc check vendor is assigned to any contingency or not
   */
  checkVendorAssigned() {
    let vendorExist = false;
    if (this.state.contingencies.length > 0) {
      for (let i = 0; i < this.state.contingencies.length; i++) {
        if (
          this.state.contingencies[i].name === "First Appointment" &&
          this.state.contingencies[i].assignee !== undefined &&
          this.state.contingencies[i].assignee !== "" &&
          this.state.contingencies[i].assignee != "no"
        ) {
          vendorExist = true;
        }
      }
    }
    return vendorExist;
  }

  okPrompt() {
    this.setState({ isShowPrompt: false, promptMsg: "", showLoader: true });
    this.submitAction();
  }

  /**
   * @desc cretate transaction api call with formated data
   */
  submitAction() {
    this.setState({
      showLoader: true,
    });
    const timestamp = new Date().getTime();
    this.setState({dateTime: timestamp});
    let data = this.state;
    this.setState({ isCampErrMsg: false });
    delete data.isCampErrMsg;
    data.contingencies = contigencyFormat(this.state.contingencies);
    // console.log("data.startDate", data.startDate);
    // console.log("data.endDate", data.endDate);
    data.startDate = new Date(data.startDate);
    data.endDate = new Date(data.endDate);
    // data.startDate = new Date();
    // data.endDate = new Date();
    data.property.zipcode = removeDashFromMobile(data.property.zipcode);

    if (data.campaign === "") {
      delete data.campaign;
    }

    if (data.property) {
      let zip = data.property.zipcode.toString();

      if (zip.length > 5) {
        let zipcode = removeDashFromMobile(data.property.zipcode);
        data.property.zipcode = zipcode;
      }
    }

    var fileNames = [];
    this.state.tempImages = data.property.image;
    var formData = new FormData();
    data.property.image.forEach((file) => {
      if (file) {
        formData.append("file", file);
        const newFileName = `${timestamp}_${file.name}`;
        // fileNames.push(file.name);
        fileNames.push(newFileName);
      }
    });

    if (this.state.drafted !== undefined) {
      let fees = data.fees;
      fees.push(this.state.drafted);
      data.fees = fees;
    }

    if (this.state.draftedEMD !== undefined) {
      let otherEMD = data.otherEMD;
      otherEMD.push(this.state.draftedEMD);
      data.otherEMD = otherEMD;
    }

    if (data.leadSource == "") {
      delete data.leadSource;
    }

    if (data.agentPercentage == "") {
      data.agentPercentage = this.props.profileData.agentPercentage;
    }

    //calculate amount
    let commissionAmt = (data.agreedOpenPrice * data.commission) / 100;
    let agentPercentageAmt = (commissionAmt * data.agentPercentage) / 100;
    let brokerPercentageAmt = commissionAmt - agentPercentageAmt;

    let fees = data.fees;
    fees.push({ name: "Brokerage Fee", value: brokerPercentageAmt });
    data.fees = fees;

    //default buyer
    let defaultbuyer = data.buyer;
    let multibuyers = data.buyers;

    if (
      defaultbuyer.email !== "" ||
      defaultbuyer.firstname ||
      defaultbuyer.lastname !== "" ||
      defaultbuyer.mobileNumber !== ""
    ) {
      //add default buyer on 0th index
      multibuyers.unshift(defaultbuyer);
    }

    for (let b = 0; b < multibuyers.length; b++) {
      if (!!multibuyers[b] && !!multibuyers[b].mobileNumber) {
        multibuyers[b].mobileNumber = removeDashFromMobile(
          multibuyers[b].mobileNumber.toString()
        );
      }
    }
    data.buyer = multibuyers;
    delete data.buyers;

    // data.listingAgents = listingAgentDataFormat(data.listingAgents);
    // data.closingAgents = closingAgentDataFormat(data.closingAgents);

    let TransactionData = {
      draft: data.draft,
      hoa: data.hoa,
      builtBefore1978: data.builtBefore1978,
      homeWarranty: data.homeWarranty,
      condo: data.condo,
      fees: data.fees,
      buyer: multibuyers,

      emd: data.emd,
      otherEMD: data.otherEMD,
      heldBy: data.heldBy,
      property: data.property,
      agreedOpenPrice: data.agreedOpenPrice,
      commission: data.commission,
      leadSource: data.leadSource,
      agentPercentage: data.agentPercentage,
      listingAgents: listingAgentDataFormat(data.listingAgents),
      closingAgents: closingAgentDataFormat(data.closingAgents),
    };
    data.dsd = TransactionData;
    data.dsd.property.image = fileNames;
    delete data.contacts;
    this.createTransaction(data);
    // if (data.property.image.length > 0) {
    //   APIUtil.postFormDataMethod(
    //     UrlConstants.uploadPropertyImage,
    //     formData,
    //     true
    //   ).then((res) => {
    //     data.dsd.property.image = fileNames;
    //     if (res.status == code.OK) {
    //       this.createTransaction(data);
    //     } else {
    //       data.dsd.property.image = [];
    //       this.createTransaction(data);
    //     }
    //   });
    // } else {
    //   data.dsd.property.image = [];
    //   this.createTransaction(data);
    // }
  }

  /**
   * @desc call api for create new transaction with given data
   * @param {*} data
   */
  createTransaction(data, createEvent, createPublicForm, grantPermissions) {
    // createEvent set as optional param (boolean)
    if (
      createEvent === undefined ||
      createEvent === false ||
      createEvent === 0 ||
      createEvent === ""
    ) {
      createEvent = false;
    }

    if (
      createPublicForm === undefined ||
      createPublicForm === false ||
      createPublicForm === 0 ||
      createPublicForm === ""
    ) {
      createPublicForm = false;
    }

    if (
      grantPermissions === undefined ||
      grantPermissions === false ||
      grantPermissions === 0 ||
      grantPermissions === ""
    ) {
      grantPermissions = false;
    }

    let defaultpathwayId = this.state.defaultPathwayid;
    this.props.createTransactionAction(data).then((res) => {
      if (this.props.isTrascationCreated === true) {
        if (!data.draft) {
          let pdata = {
            status: "INPROGRESS",
            startDate: this.props.createTransactionData.startDate,
            endDate: this.props.createTransactionData.endDate,
          };
          pdata.showSuccessMessage = false;
          // console.log("i am 143", this.props.createTransactionData);
          this.props
            .changeTransactionStatusAction(
              this.props.createTransactionData._id,
              pdata
            )
            .then((res1) => {
              console.log("res1", res);
              if (res._id) {
                if (this.state.tempImages.length > 0) {
                  var formData = new FormData();
                  this.state.tempImages.forEach((file) => {
                    if (file) {
                      // formData.append("file", file);
                      const newFileName = `${this.state.dateTime}_${file.name}`;
                      formData.append("file",  file, newFileName );
                    }
                  });
                  let url = `${
                    UrlConstants.uploadPropertyImage
                  }?transactionId=${res._id}`;
                  APIUtil.postFormDataMethod(
                    url,
                    formData,
                    true
                  ).then((res) => {});
                }
              }
              toastMessage(code.SUCCESS, "Artwork added");
              this.setState(this.defaultState);
              this.props.history.push("/artwork");
              // creating public forms + events
              createPublicForm = true;
              if (createPublicForm) {
                let paperworkDate = getContingencyData(
                  res.contingencies,
                  "Paperwork",
                  "startDate"
                );
                let newPublicForm = {
                  form: "intake",
                  transactionId: res._id,
                  expiresOn: new Date(
                    moment(paperworkDate).subtract(5, "days")
                  ),
                  auth: false,
                };
                this.props
                  .addPublicFormAction(newPublicForm)
                  .then((newPubRes1) => {});

                newPublicForm = {
                  form: "consent",
                  transactionId: res._id,
                  expiresOn: new Date(
                    moment(paperworkDate).subtract(5, "days")
                  ),
                  auth: false,
                };
                this.props
                  .addPublicFormAction(newPublicForm)
                  .then((newPubRes2) => {});

                newPublicForm = {
                  form: "aftercare",
                  transactionId: res._id,
                  expiresOn: new Date(moment(paperworkDate).add(20, "days")),
                  auth: false,
                };
                this.props
                  .addPublicFormAction(newPublicForm)
                  .then((newPubRes3) => {});
              }

              if (defaultpathwayId !== "") {
                let pathwaysStartdate = getContingencyData(
                  res.contingencies,
                  "First Appointment",
                  "startDate"
                );

                // const originalDate = new Date(pathwaysStartdate);
                // console.log("originalDate", originalDate);
                // const momentObj = moment(originalDate);
                // const utcFormattedDate = momentObj
                //   .utc()
                //   .format("YYYY-MM-DDTHH:mm:ss[Z]");

                const utcFormattedDate = getUTCdate(pathwaysStartdate);

                // console.log("utcFormattedDate", utcFormattedDate);

                // const momentObjutc = moment(utcFormattedDate);

                // const convertedDate = momentObjutc
                //   .tz(this.props.createTransactionData.userTimezone)
                //   .format("YYYY-MM-DDTHH:mm:ss[Z]");

                // console.log("convertedDate", convertedDate);

                // const timeMin =
                //   convertedDate.split("T")[1].split(":")[0] * 60 +
                //   parseInt(convertedDate.split("T")[1].split(":")[1], 10);

                // const timeMin = getMinutesWithUTCTZ(
                //   pathwaysStartdate,
                //   this.props.createTransactionData.userTimezone
                // );

                // let timeMin = getMinutes(convertedDate);
                // console.log("timeMin-638", timeMin);

                let timeMin = getMinutes(pathwaysStartdate);
                // console.log("644-timeMin2", timeMin);

                let time3 = getMinutes(utcFormattedDate);
                // console.log("644-time3", time3);

                let firstAppoEnddate = getContingencyData(
                  res.contingencies,
                  "First Appointment",
                  "endDate"
                );

                // console.log("add pathway firstAppoEnddate", firstAppoEnddate);

                let pathwaytimeMin = getMinutes(pathwaysStartdate);

                // console.log("add pathway timeMin", pathwaytimeMin);

                let endTimeMin = getMinutes(firstAppoEnddate);

                // console.log("add pathway endTimeMin", endTimeMin);

                let timeDiff = endTimeMin - pathwaytimeMin;

                // console.log("add pathway timeDiff", timeDiff);

                // add default pathways task
                let data = {
                  transactionId: res._id,
                  pathwayId: defaultpathwayId,
                  startDate: utcFormattedDate,
                  startDateTime: utcFormattedDate,
                  time: timeMin,
                  timeDiff: timeDiff,
                };

                this.props.addPathwayToTransactionAction(data).then((res) => {
                  if (res.status === code.OK) {
                    toastMessage(code.SUCCESS, "Pathway added successfully");
                  } else {
                    this.setState({ errors: res.data });
                  }
                });
              }

              // creating events
              createEvent = true;
              if (createEvent) {
                let contiDate = "";
                let contiTimeStr = "";
                let firstApptUTC = getContingencyData(
                  res.contingencies,
                  "First Appointment",
                  "startDate"
                );
                let firstApptDate = moment(firstApptUTC).format("M/DD/YYYY");
                let today = getToday();
                // let newEvent = {
                //   assignee: "@artist",
                //   campaign: "",
                //   communicationSubject: [""],
                //   communicationTo: [""],
                //   communicationToUserId: [""],
                //   communicationType: "",
                //   contingency: "First Appointment",
                //   day: 0,
                //   description: [
                //     "<p>First appointment with @client_firstname @client_lastname on @first_appointment_date.</p>\n",
                //   ],
                //   document: false,
                //   eventEndDate: "",
                //   eventStartDate: "",
                //   eventType: "INTERACTIVE",
                //   isReminder: false,
                //   reminderDate: "",
                //   reminderTime: 480,
                //   specialTask: ["Appointment"],
                //   status: "SCHEDULED",
                //   time: 0,
                //   timeZone: "240",
                //   title: "First Appointment",
                //   transactionId: res._id,
                // };
                // if (
                //   newEvent.eventEndDate === "" &&
                //   newEvent.eventStartDate === "" &&
                //   newEvent.time === 0
                // ) {
                //   newEvent.eventEndDate = getContingencyData(
                //     res.contingencies,
                //     "First Appointment",
                //     "endDate"
                //   );
                //   newEvent.eventStartDate = getContingencyData(
                //     res.contingencies,
                //     "First Appointment",
                //     "startDate"
                //   );
                //   newEvent.communicationToUserId = getContingencyData(
                //     res.contingencies,
                //     "First Appointment",
                //     "assignee"
                //   );

                //   contiDate = new Date(newEvent.eventStartDate);
                //   contiTimeStr =
                //     contiDate.getHours() + ":" + contiDate.getMinutes();
                //   newEvent.time = convertTimeToMinutes(contiTimeStr);

                //   //newEvent.reminderDate = new Date(moment(newEvent.eventEndDate).subtract(2, 'days'));
                // }
                // if (newEvent.eventEndDate && newEvent.eventStartDate) {
                //   this.props.createTaskAction(newEvent).then((res2) => {});
                // }
                let newEvent = {
                  assignee: "@client",
                  campaign: "",
                  communicationSubject: [""],
                  communicationTo: [""],
                  communicationToUserId: [""],
                  communicationType: "EMAIL",
                  contingency: "Paperwork",
                  day: 0,
                  description: [
                    "<p>@client_firstname, please complete the paperwork for your appointment with @artist_firstname @artist_lastname by the date indicated on this task. Links to the required forms have been sent to your email. Thanks!</p>\n",
                  ],
                  document: false,
                  eventEndDate: "",
                  eventStartDate: "",
                  eventType: "INTERACTIVE",
                  isReminder: false,
                  reminderDate: "",
                  reminderTime: 480,
                  specialTask: ["Paperwork"],
                  status: "SCHEDULED",
                  time: 0,
                  timeZone: "240",
                  title: "Paperwork",
                  transactionId: res._id,
                };
                if (
                  newEvent.eventEndDate === "" &&
                  newEvent.eventStartDate === "" &&
                  newEvent.time === 0
                ) {
                  newEvent.eventEndDate = getContingencyData(
                    res.contingencies,
                    "Paperwork",
                    "endDate"
                  );
                  newEvent.eventStartDate = getContingencyData(
                    res.contingencies,
                    "Paperwork",
                    "startDate"
                  );
                  newEvent.communicationToUserId = getContingencyData(
                    res.contingencies,
                    "Paperwork",
                    "assignee"
                  );

                  contiDate = new Date(newEvent.eventStartDate);
                  contiTimeStr =
                    contiDate.getHours() + ":" + contiDate.getMinutes();
                  // newEvent.time = convertTimeToMinutes(contiTimeStr);
                  newEvent.time = 540;

                  //newEvent.reminderDate = new Date(moment(newEvent.eventEndDate).subtract(2, 'days'));
                }
                if (newEvent.eventEndDate && newEvent.eventStartDate) {
                  this.props.createTaskAction(newEvent).then((res2) => {});
                }
                //   newEvent = {
                //     assignee: "",
                //     campaign: "",
                //     communicationSubject: [
                //       "Your Appointment With @artist_firstname @artist_lastname",
                //     ],
                //     communicationTo: ["@client_email"],
                //     communicationType: "EMAIL",
                //     contingency: "First Appointment",
                //     day: 0,
                //     description: [
                //       "<p>Hey @client_firstname!</p><p></p><p>Your appointment with @artist_firstname @artist_lastname is on @first_appointment_date. See you then!</p>",
                //     ],
                //     document: false,
                //     eventEndDate: "",
                //     eventStartDate: "",
                //     eventType: "COMMUNICATION",
                //     isReminder: false,
                //     reminderDate: "",
                //     reminderTime: 480,
                //     specialTask: [""],
                //     status: "SCHEDULED",
                //     time: 0,
                //     timeZone: "240",
                //     title: "First Appointment Reminder - Client Email",
                //     transactionId: res._id,
                //   };
                //   if (
                //     newEvent.eventEndDate === "" &&
                //     newEvent.eventStartDate === "" &&
                //     newEvent.time === 0
                //   ) {
                //     // //Get the Start date of the new appointment -- Set the date to send the reminder email 2 days before the appointment
                //     let localRemiderDate = getContingencyData(
                //       res.contingencies,
                //       "First Appointment",
                //       "startDate"
                //     );
                //     newEvent.eventStartDate = new Date(
                //       moment(localRemiderDate).subtract(2, "days")
                //     );
                //     newEvent.eventEndDate = new Date(
                //       moment(localRemiderDate).subtract(2, "days")
                //     );

                //     // //newEvent.eventEndDate = getContingencyData(res.contingencies, "First Appointment", "endDate");
                //     // //newEvent.eventStartDate = getContingencyData(res.contingencies, "First Appointment", "startDate");

                //     contiDate = new Date(newEvent.eventStartDate);
                //     contiTimeStr =
                //       contiDate.getHours() + ":" + contiDate.getMinutes();
                //     newEvent.time = convertTimeToMinutes(contiTimeStr);

                //     //newEvent.reminderDate = new Date(moment(newEvent.eventStartDate).subtract(2, 'days'));
                //   }
                //   if (
                //     newEvent.eventEndDate &&
                //     newEvent.eventStartDate &&
                //     newEvent.time &&
                //     firstApptDate !== today
                //   ) {
                //     this.props.createTaskAction(newEvent).then((res3) => {});
                //   }
                //   newEvent = {
                //     assignee: "",
                //     campaign: "",
                //     communicationSubject: [""],
                //     communicationTo: ["@client_phone"],
                //     communicationType: "TEXT",
                //     contingency: "First Appointment",
                //     day: 0,
                //     description: [
                //       "Hey @client_firstname! Your appointment with @artist_firstname @artist_lastname is on @first_appointment_date. See you then!",
                //     ],
                //     document: false,
                //     eventEndDate: "",
                //     eventStartDate: "",
                //     eventType: "COMMUNICATION",
                //     isReminder: false,
                //     reminderDate: "",
                //     reminderTime: 480,
                //     specialTask: [""],
                //     status: "SCHEDULED",
                //     time: 0,
                //     timeZone: "240",
                //     title: "First Appointment Reminder - Client Text",
                //     transactionId: res._id,
                //   };
                //   if (
                //     newEvent.eventEndDate === "" &&
                //     newEvent.eventStartDate === "" &&
                //     newEvent.time === 0
                //   ) {
                //     //Get the Start date of the new appointment -- Set the date to send the reminder email 2 days before the appointment
                //     let localRemiderDate = getContingencyData(
                //       res.contingencies,
                //       "First Appointment",
                //       "startDate"
                //     );
                //     newEvent.eventStartDate = new Date(
                //       moment(localRemiderDate).subtract(2, "days")
                //     );
                //     newEvent.eventEndDate = new Date(
                //       moment(localRemiderDate).subtract(2, "days")
                //     );

                //     //newEvent.eventEndDate = getContingencyData(res.contingencies, "First Appointment", "endDate");
                //     //newEvent.eventStartDate = getContingencyData(res.contingencies, "First Appointment", "startDate");

                //     contiDate = new Date(newEvent.eventStartDate);
                //     contiTimeStr =
                //       contiDate.getHours() + ":" + contiDate.getMinutes();
                //     newEvent.time = convertTimeToMinutes(contiTimeStr);

                //     //newEvent.reminderDate = new Date(moment(newEvent.eventEndDate).subtract(2, 'days'));
                //   }
                //   if (
                //     newEvent.eventEndDate &&
                //     newEvent.eventStartDate &&
                //     newEvent.time &&
                //     firstApptDate !== today
                //   ) {
                //     this.props.createTaskAction(newEvent).then((res4) => {});
                //   }
                //   newEvent = {
                //     assignee: "",
                //     campaign: "",
                //     communicationSubject: [
                //       "New Appointment With @client_firstname @client_lastname",
                //     ],
                //     communicationTo: ["@artist_email"],
                //     communicationType: "EMAIL",
                //     contingency: "First Appointment",
                //     day: 0,
                //     description: [
                //       '<p>Hey <a href="" class="wysiwyg-mention" data-mention="" data-value="artist_firstname">@artist_firstname</a>!</p><p></p><p>Your appointment with <a href="" class="wysiwyg-mention" data-mention="" data-value="client_firstname">@client_firstname</a> <a href="" class="wysiwyg-mention" data-mention="" data-value="client_lastname">@client_lastname</a> is on @first_appointment_date. Details are in DotWork. Thanks!</p>',
                //     ],
                //     document: false,
                //     eventEndDate: "",
                //     eventStartDate: "",
                //     eventType: "COMMUNICATION",
                //     isReminder: false,
                //     reminderDate: "",
                //     reminderTime: 480,
                //     specialTask: [""],
                //     status: "SCHEDULED",
                //     time: 0,
                //     timeZone: "240",
                //     title: "New Appointment Scheduled - Artist Email",
                //     transactionId: res._id,
                //   };
                //   if (
                //     newEvent.eventEndDate === "" &&
                //     newEvent.eventStartDate === "" &&
                //     newEvent.time === 0
                //   ) {
                //     //Get the Start date of the new appointment -- Set the date to send the reminder email 2 days before the appointment
                //     let localRemiderDate = getContingencyData(
                //       res.contingencies,
                //       "First Appointment",
                //       "startDate"
                //     );
                //     newEvent.eventStartDate = new Date(
                //       moment(localRemiderDate).subtract(2, "days")
                //     );
                //     newEvent.eventEndDate = new Date(
                //       moment(localRemiderDate).subtract(2, "days")
                //     );

                //     //newEvent.eventEndDate = getContingencyData(res.contingencies, "First Appointment", "endDate");
                //     //newEvent.eventStartDate = getContingencyData(res.contingencies, "First Appointment", "startDate");

                //     contiDate = new Date(newEvent.eventStartDate);
                //     contiTimeStr =
                //       contiDate.getHours() + ":" + contiDate.getMinutes();
                //     newEvent.time = convertTimeToMinutes(contiTimeStr);

                //     //newEvent.reminderDate = new Date(moment(newEvent.eventEndDate).subtract(2, 'days'));
                //   }
                //   if (
                //     newEvent.eventEndDate &&
                //     newEvent.eventStartDate &&
                //     newEvent.time &&
                //     firstApptDate !== today
                //   ) {
                //     this.props.createTaskAction(newEvent).then((res5) => {});
                //   }
                //   newEvent = {
                //     assignee: "",
                //     campaign: "",
                //     communicationSubject: [""],
                //     communicationTo: ["@artist_phone"],
                //     communicationType: "TEXT",
                //     contingency: "First Appointment",
                //     day: 0,
                //     description: [
                //       "Hey @artist_firstname! Your appointment with @client_firstname @client_lastname is on @first_appointment_date. Details are in DotWork. Thanks!",
                //     ],
                //     document: false,
                //     eventEndDate: "",
                //     eventStartDate: "",
                //     eventType: "COMMUNICATION",
                //     isReminder: false,
                //     reminderDate: "",
                //     reminderTime: 480,
                //     specialTask: [""],
                //     status: "SCHEDULED",
                //     time: 0,
                //     timeZone: "240",
                //     title: "New Appointment Scheduled - Artist Text",
                //     transactionId: res._id,
                //   };
                //   if (
                //     newEvent.eventEndDate === "" &&
                //     newEvent.eventStartDate === "" &&
                //     newEvent.time === 0
                //   ) {
                //     //Get the Start date of the new appointment -- Set the date to send the reminder email 2 days before the appointment
                //     let localRemiderDate = getContingencyData(
                //       res.contingencies,
                //       "First Appointment",
                //       "startDate"
                //     );
                //     newEvent.eventStartDate = new Date(
                //       moment(localRemiderDate).subtract(2, "days")
                //     );
                //     newEvent.eventEndDate = new Date(
                //       moment(localRemiderDate).subtract(2, "days")
                //     );

                //     //newEvent.eventEndDate = getContingencyData(res.contingencies, "First Appointment", "endDate");
                //     //newEvent.eventStartDate = getContingencyData(res.contingencies, "First Appointment", "startDate");

                //     contiDate = new Date(newEvent.eventStartDate);
                //     contiTimeStr =
                //       contiDate.getHours() + ":" + contiDate.getMinutes();
                //     newEvent.time = convertTimeToMinutes(contiTimeStr);

                //     //newEvent.reminderDate = new Date(moment(newEvent.eventEndDate).subtract(2, 'days'));
                //   }
                //   if (
                //     newEvent.eventEndDate &&
                //     newEvent.eventStartDate &&
                //     newEvent.time &&
                //     firstApptDate !== today
                //   ) {
                //     this.props.createTaskAction(newEvent).then((res6) => {});
                //   }
                //   newEvent = {
                //     assignee: "",
                //     campaign: "",
                //     communicationSubject: [""],
                //     communicationTo: ["@client_phone"],
                //     communicationType: "TEXT",
                //     contingency: "First Appointment",
                //     day: 0,
                //     description: [
                //       "Hey @client_firstname, thanks for visiting us! Remember to follow the aftercare instructions provided by your artist, @artist_firstname @artist_lastname. If you have any questions or concerns, please contact @artist_firstname at @artist_phone. Enjoy your new tattoo!",
                //     ],
                //     document: false,
                //     eventEndDate: "",
                //     eventStartDate: "",
                //     eventType: "COMMUNICATION",
                //     isReminder: false,
                //     reminderDate: "",
                //     reminderTime: 480,
                //     specialTask: [""],
                //     status: "SCHEDULED",
                //     time: 540,
                //     timeZone: "240",
                //     title: "Post-Appointment - Text",
                //     transactionId: res._id,
                //   };
                //   if (
                //     newEvent.eventEndDate === "" &&
                //     newEvent.eventStartDate === ""
                //   ) {
                //     contiDate = getContingencyData(
                //       res.contingencies,
                //       "First Appointment",
                //       "startDate"
                //     );

                //     newEvent.eventEndDate = new Date(
                //       moment(contiDate).add(1, "days")
                //     );
                //     newEvent.eventStartDate = new Date(
                //       moment(contiDate).add(1, "days")
                //     );

                //     let contiDate1 = new Date(newEvent.eventStartDate);
                //     contiTimeStr =
                //       contiDate1.getHours() + ":" + contiDate1.getMinutes();
                //     newEvent.time = convertTimeToMinutes(contiTimeStr);

                //     //newEvent.reminderDate = new Date(moment(newEvent.eventEndDate).subtract(2, 'days'));
                //   }
                //   if (
                //     newEvent.eventEndDate &&
                //     newEvent.eventStartDate &&
                //     newEvent.time
                //   ) {
                //     this.props.createTaskAction(newEvent).then((res5) => {});
                //   }
                //   newEvent = {
                //     assignee: "",
                //     campaign: "",
                //     communicationSubject: [""],
                //     communicationTo: ["@client_phone"],
                //     communicationType: "TEXT",
                //     contingency: "First Appointment",
                //     day: 0,
                //     description: [
                //       "Hey @client_firstname! How's your tattoo doing? If it's okay with you, we'd love a pic. Just log into Dotwork https://www.dotworksoftware.com , go to your Artwork, and upload it to Healed Tattoo Photo under Tasks. Thanks!",
                //     ],
                //     document: false,
                //     eventEndDate: "",
                //     eventStartDate: "",
                //     eventType: "COMMUNICATION",
                //     isReminder: false,
                //     reminderDate: "",
                //     reminderTime: 480,
                //     specialTask: [""],
                //     status: "SCHEDULED",
                //     time: 540,
                //     timeZone: "240",
                //     title: "Post-Healing Photo Upload Text",
                //     transactionId: res._id,
                //   };
                //   if (
                //     newEvent.eventEndDate === "" &&
                //     newEvent.eventStartDate === ""
                //   ) {
                //     contiDate = getContingencyData(
                //       res.contingencies,
                //       "First Appointment",
                //       "startDate"
                //     );

                //     newEvent.eventEndDate = new Date(
                //       moment(contiDate).add(3, "weeks")
                //     );
                //     newEvent.eventStartDate = new Date(
                //       moment(contiDate).add(3, "weeks")
                //     );

                //     let contiDate1 = new Date(newEvent.eventStartDate);
                //     contiTimeStr =
                //       contiDate1.getHours() + ":" + contiDate1.getMinutes();
                //     newEvent.time = convertTimeToMinutes(contiTimeStr);
                //   }
                //   if (
                //     newEvent.eventEndDate &&
                //     newEvent.eventStartDate &&
                //     newEvent.time
                //   ) {
                //     this.props.createTaskAction(newEvent).then((res6) => {});
                //   }
                //   newEvent = {
                //     assignee: "@client",
                //     campaign: "",
                //     communicationSubject: [""],
                //     communicationTo: [""],
                //     communicationType: "EMAIL",
                //     contingency: "First Appointment",
                //     day: 0,
                //     description: [
                //       "<p>Hey @client_firstname! Please upload a photo of your healed tattoo to this task. Thanks!</p>\n",
                //     ],
                //     document: true,
                //     eventEndDate: "",
                //     eventStartDate: "",
                //     eventType: "INTERACTIVE",
                //     isReminder: false,
                //     reminderDate: "",
                //     reminderTime: 480,
                //     specialTask: [""],
                //     status: "SCHEDULED",
                //     time: 540,
                //     timeZone: "240",
                //     title: "Healed Tattoo Photo",
                //     transactionId: res._id,
                //   };
                //   if (
                //     newEvent.eventEndDate === "" &&
                //     newEvent.eventStartDate === ""
                //   ) {
                //     contiDate = getContingencyData(
                //       res.contingencies,
                //       "First Appointment",
                //       "startDate"
                //     );

                //     newEvent.eventEndDate = new Date(
                //       moment(contiDate).add(3, "weeks")
                //     );
                //     newEvent.eventStartDate = new Date(
                //       moment(contiDate).add(3, "weeks")
                //     );

                //     let contiDate1 = new Date(newEvent.eventStartDate);
                //     contiTimeStr =
                //       contiDate1.getHours() + ":" + contiDate1.getMinutes();
                //     newEvent.time = convertTimeToMinutes(contiTimeStr);
                //   }
                //   if (
                //     newEvent.eventEndDate &&
                //     newEvent.eventStartDate &&
                //     newEvent.time
                //   ) {
                //     this.props.createTaskAction(newEvent).then((res7) => {});
                //   }
              }
              // granting folder permissions
              grantPermissions = true;
              let hasGuardian =
                res.dsd.closingAgents.length === 0 ? false : true;
              if (grantPermissions && !hasGuardian) {
                let permissionObj = {
                  canView: true,
                  canAdd: true,
                  canMove: false,
                  canDelete: false,
                  userId: res.dsd.buyerId,
                };

                let permissionData = {
                  transactionId: res._id,
                  location: "Transaction Docs",
                  permission: permissionObj,
                };

                this.props
                  .setFolderPermissionAction(permissionData)
                  .then((permRes) => {});
              } else {
                let permissionObj = [];

                permissionObj.push(
                  {
                    canView: true,
                    canAdd: true,
                    canMove: false,
                    canDelete: false,
                    userId: res.dsd.closingAgents[0].id, // guardian details for default permissions
                  },
                  {
                    canView: true,
                    canAdd: true,
                    canMove: false,
                    canDelete: false,
                    userId: res.dsd.buyerId[0],
                  }
                );

                let permissionData = {
                  transactionId: res._id,
                  location: "Transaction Docs",
                  permission: permissionObj,
                };

                this.props
                  .setFolderPermissionAction(permissionData)
                  .then((permRes) => {});
              }
            });
        } else {
          this.setState(this.defaultState);
          this.props.history.push("/artwork");
        }
        // if (
        //   cryptoTokenDecode().usertype === message.ACCTOWNER &&
        //   localStorage.getItem(code.IS_STRIPE_ENABLED) === "true"
        // ) {
        //   this.props.getSubscriptionCounterAction().then((counterRes) => {
        //     localStorage.setItem(
        //       "transactionCount",
        //       counterRes[0].transactionLimitCounter
        //     );
        //   });
        // }
        // if (
        //   cryptoTokenDecode().usertype === message.VENDOR &&
        //   this.currentRole === message.BUYERAGENT &&
        //   localStorage.getItem(code.IS_STRIPE_ENABLED) === "true"
        // ) {
        //   this.props.getSubscriptionCounterAction().then((counterRes) => {
        //     localStorage.setItem(
        //       "transactionCount",
        //       counterRes[0].transactionLimitCounter
        //     );
        //   });
        // }
      } else {
        toastMessage(code.ERROR, res);
        this.setState(this.defaultState);
        this.props.history.push("/artwork");
      }
    });
  }

  /**
   * @desc start transaction api call after transaction created
   */
  changeTransactionStatus(transId, data) {
    // console.log("i am herr", transId);
    this.props.changeTransactionStatusAction(transId, data).then((res) => {
      this.setState(this.defaultState);
      this.props.history.push("/artwork");
    });
  }

  updateErrMsg(i) {
    if (i == 0) {
      this.setState({ isCampErrMsg: false });
    } else {
      this.setState({ isCampErrMsg: true });
    }
  }

  /**
   * @desc transaction save as draft
   * @param {*} step
   */
  saveAsDraft(step) {
    this.setState({ draft: true }, () => {
      if (step == 2) {
        this.checkShortName(this.state.shortName).then((res) => {
          if (res.isAccepted) {
            this.submitAction();
          } else {
            this.setState({ shortNameErr: code.ERROR });
            $("#prev-button").trigger("click");
            //If step 1 have validation errors
            return false;
          }
        });
      }
    });
  }

  //Check unique short name
  checkShortName = (name) =>
    new Promise((resolve, reject) => {
      this.props.checkTransShortNameAction(name).then((res) => {
        let isAccepted = false;
        if (res.status === code.ACCEPTED) {
          isAccepted = true;
          this.setState({ shortNameErr: "" });
        }
        resolve({ isAccepted: isAccepted });
      });
    });

  /**
   * @desc check vendor email is exist or not
   */
  checkVendor = (email) =>
    new Promise((resolve, reject) => {
      if (email != "") {
        this.props.getContactByEmailAction(email).then((res) => {
          if (res == "Unauthorized") {
            resolve({ contact: "" });
            toastMessage(code.ERROR, message.INVALID_USER_SELECTION);
          } else {
            if (Object.keys(res).length > 0) {
              var contact = {
                role: res.role ? res.role[0] : "",
                usertype: message.VENDOR,
                firstname: res.firstname,
                lastname: res.lastname,
                mobileNumber: formatPhoneNumber(res.mobileNumber),
                email: email,
                companyName: !!res.companyInformation
                  ? res.companyInformation.name
                  : "",
              };
              resolve({ contact: contact });
            } else {
              resolve({ contact: "" });
            }
          }
        });
      }
    });

  render() {
    // console.log('acctowners: ', this.state.users);
    const steps = [
      {
        component: (
          <PropertyInfo
            profileData={this.props.profileData}
            leadSourceOptions={this.props.leadSourceOptions}
            timezoneList={this.props.timezoneList}
            transactionType={this.props.transactionType}
            getTransactionData={() => this.getTransactionData()}
            updateTransactionData={(k, v) => {
              this.updateTransactionData(k, v);
            }}
            saveAsDraft={(step) => {
              this.saveAsDraft(step);
            }}
            getCityState={(zip) => this.props.getAddressFromZipcodeAction(zip)}
            checkShortName={(name) => this.checkShortName(name)}
            isDrafted={false}
            onRef={(ref) => (this.child = ref)}
            shortNameErr={this.state.shortNameErr}
            checkVendor={(email) => this.checkVendor(email)}
          />
        ),
      },
      {
        component: (
          <AssignVendor
            getTransactionData={() => this.getTransactionData()}
            updateTransactionData={(k, v) => {
              this.updateTransactionData(k, v);
            }}
            updateErrMsg={(i) => this.updateErrMsg(i)}
            saveAsDraft={(step) => {
              this.saveAsDraft(step);
            }}
            isDrafted={false}
            contacts={this.state.contacts}
          />
        ),
      },
    ];

    if (this.state.showLoader) {
      return (
        <div className="page-loader fixed">
          <div className="page-loader-inner">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="step-progress transaction-create">
          <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center">
            <Col xs={12} sm={3}>
              <h4 className="title-med mt-0 pt-1">Create Artwork</h4>
            </Col>

            <Col xs={12} sm={6} />

            <Col xs={12} sm={3} align="right" className="transaction-close">
              <Link to="/artwork" className="nav-link p-0 color-black">
                <Close
                  style={{ stroke: "#fff", height: "40px", width: "40px" }}
                />
              </Link>
            </Col>
          </Row>
          <div className="multi-step multi-step-admin">
            <StepZilla
              showNavigation={true}
              steps={steps}
              backButtonCls="btn btn-sm btn-primary btn-blue btn-outlined w-140 mr-3"
              nextButtonCls={"btn btn-sm btn-primary btn-blue w-140 saveBtn"}
              backButtonText="Back"
              onStepChange={(step) => this.getLastStep(step)}
              hocValidationAppliedTo={[0]}
              preventEnterSubmission={true}
            />
          </div>

          <Modal
            show={this.state.isShowPrompt}
            dialogClassName="modal-90w"
            aria-labelledby="example-custom-modal-styling-title"
            className="modal-med modal-400 modal-delete"
            centered
            backdrop={false}
          >
            <Modal.Body className="pb-0 text-center">
              <HelpOutline />
              <p>{this.state.promptMsg}</p>
            </Modal.Body>
            <Modal.Footer>
              <Button
                variant="primary"
                className="btn-blue btn-outlined w-140"
                onClick={() => {
                  this.isShowPrompt();
                }}
              >
                Cancel
              </Button>
              <Button
                variant="primary"
                className="btn-blue w-140"
                onClick={() => {
                  this.okPrompt();
                }}
              >
                Yes
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    isTrascationCreated: state.reducer.isTrascationCreated,
    createTransactionData: state.reducer.createTransactionData,
    leadSourceOptions: state.reducer.options,
    profileData: state.reducer.profileData,
    timezoneList: state.reducer.timezoneList,
    transactionType: state.reducer.transactionType,
    contacts: state.reducer.contacts,
    roles: state.reducer.roles,
    taskData: state.reducer.taskData,
    buyerAgents: state.reducer.buyerAgents,
    addPublicFormData: state.reducer.addPublicFormData,
    getPublicFormData: state.reducer.getPublicFormData,
    buyerMasterTemplates: state.reducer.buyerMasterTemplates,
  };
};

export default connect(
  mapStateToProps,
  {
    createTransactionAction,
    getLeadSourceOptionsAction,
    getAddressFromZipcodeAction,
    checkTransShortNameAction,
    changeTransactionStatusAction,
    getContactByEmailAction,
    getSubscriptionCounterAction,
    getTimezoneListAction,
    getTransactionTypeAction,
    getContactsActions,
    getUserRolesAction,
    createTaskAction,
    buyerAgentsAction,
    addPublicFormAction,
    getPublicFormAction,
    setFolderPermissionAction,
    getBuyerAgentMasterTemplateAction,
    addPathwayToTransactionAction,
  }
)(CreateTransaction);
